import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Api } from '../../services/api';
import { Globals } from '../../services/globals';

@Component({
    selector: 'latest-orders',
    templateUrl: './latest-orders.component.html',
    styleUrls: ['./latest-orders.component.scss'],
    standalone: false
})
export class LatestOrdersComponent {
    orders?: any[];

    constructor(private api: Api, private router: Router, private route: ActivatedRoute, private globals: Globals) {

    }

    async ngOnInit() {
      this.orders = await this.api.store().get<any>(`/latest-orders`);
    }

}
